export const getProject = /* GraphQL */ `
  query GetProject($id: ID!) {
    getProject(id: $id) {
      id
      name
      likiees {
        items {
          id
          projectID
          likieeID
          createdAt
          updatedAt
          _lastChangedAt
          owner
        }
        nextToken
      }
      owner {
        id
        name
        email
        gender
        createdAt
        updatedAt
        _lastChangedAt
      }
      projectOwnerId
      visibility
      visibilityGroup
      itemsCount
      createdAt
      updatedAt
      _lastChangedAt
      friendProjectsId
    }
  }
`;

export const listProjects = /* GraphQL */ `
  query ListProjects(
    $id: ID
    $filter: ModelProjectFilterInput
    $limit: Int
    $nextToken: String
    $sortDirection: ModelSortDirection
  ) {
    listProjects(id: $id, filter: $filter, limit: $limit, nextToken: $nextToken, sortDirection: $sortDirection) {
      items {
        id
        name
        icon
        visibility
        visibilityGroup
        itemsCount
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;

export const getSharedProjectsWithMe = /* GraphQL */ `
  query getSharedProjectsWithMe($limit: Int, $nextToken: String) {
    getSharedProjectsWithMe(limit: $limit, nextToken: $nextToken) {
      items {
        id
        name
        icon
        visibility
        visibilityGroup
        itemsCount
        createdAt
        updatedAt
        owner
        user {
          picture
          id
          name
          email
        }
      }
      nextToken
    }
  }
`;

export const searchProjects = /* GraphQL */ `
  query searchProjects($filter: SearchableProjectFilterInput) {
    searchProjects(filter: $filter) {
      items {
        icon
        id
        itemsCount
        name
        owner
        visibility
        visibilityGroup
      }
    }
  }
`;

export const getCategoriesData = /* GraphQL */ `
  query getCategories {
    getCategories {
      icon
      likieesCount
      name
      tag
    }
  }
`;

export const getCategoryLikees = /* GraphQL */ `
  query getCategoryLikees($categoryTag: String!, $limit: Int) {
    getCategoryLikees(categoryTag: $categoryTag, limit: $limit) {
      items {
        id
        source {
          url
          name
          faviconURL
        }
        projects {
          items {
            id
          }
        }
        thumbnailURLs
        images
        status
        url
        imageURL
        price
        originalPrice
        priceTrend
        priceRange {
          min
          max
          currency
          count
        }
        currency
        name
        createdAt
      }
    }
  }
`;
